export const REWARD_REGISTRATION_STORAGE = 'rewards-registration'
export const REWARD_REGISTRATION_TTL = 24 * 60 * 60 * 1000

export interface RewardRegistrationIntent {
  referralCode: string
  expiresAt: number
  consent?: { email: string, termsVersion: string }
}

export function rewardReferralCode(value: unknown): string {
  return typeof value === 'string' && /^[\w-]{1,128}$/.test(value.trim()) ? value.trim() : ''
}

/** Consent is never inferred from a referral link or restored after its short registration window. */
export function parseRewardRegistration(value: string | null, now = Date.now()): RewardRegistrationIntent | null {
  try {
    const data: unknown = JSON.parse(value || 'null')
    if (!data || typeof data !== 'object' || !('expiresAt' in data) || typeof data.expiresAt !== 'number'
      || !Number.isFinite(data.expiresAt) || data.expiresAt <= now || data.expiresAt > now + REWARD_REGISTRATION_TTL) {
      return null
    }
    const referralCode = rewardReferralCode('referralCode' in data ? data.referralCode : '')
    let consent: RewardRegistrationIntent['consent']
    if ('consent' in data && data.consent && typeof data.consent === 'object') {
      const candidate = data.consent
      if ('email' in candidate && typeof candidate.email === 'string' && candidate.email.includes('@')
        && 'termsVersion' in candidate && typeof candidate.termsVersion === 'string' && candidate.termsVersion.trim()) {
        consent = { email: candidate.email.trim().toLowerCase(), termsVersion: candidate.termsVersion }
      }
    }
    return referralCode || consent ? { referralCode, consent, expiresAt: data.expiresAt } : null
  }
  catch {
    return null
  }
}
